import axios from 'axios';
import {
  all,
  put,
  takeEvery,
} from 'redux-saga/effects';
import config from '../../../config';
import {
  initialize,
  setResultPreview,
  setAttachPreview,
} from './actions';
import {
  ResultPreviewAction,
  ResultPreviewActionConstants,
  RequestResultPreviewArgs,
  RequestAttachPreviewArgs,
} from './types';
import { requestResultDetails } from '../resultDetails/actions';
import { LoginActionConstants } from '../login/types';

function* initializeFlow() {
  yield takeEvery(LoginActionConstants.LOGIN_SESSION_SET, function* _() {
    const { location } = window;
    const searchParams = new URLSearchParams(location.search);
    const actionCommand = searchParams.get('action') || undefined;
    if (actionCommand) {
      const commandSplit = atob(actionCommand).split('&');
      const requestId = commandSplit[1];

      yield put(requestResultDetails({ id: btoa(`request_list_id|lab-connect|${requestId}`) || '' }));
    }

    yield put(initialize());
  });
}

function* requestResultPreviewFlow() {
  yield takeEvery(ResultPreviewActionConstants.RESULT_PREVIEW_REQUEST,
    function* _(act: ResultPreviewAction<RequestResultPreviewArgs>) {
      let getError: any;
      let byteArray: any;
      let file: any;
      yield axios(`${config.backendUrl}v1/Result/GetResultPreview`, {
        headers: {
          Authorization: window.authToken || '',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        data: {
          form: {
            formId: act.form.formId,
            formCode: act.form.formCode,
            formName: act.form.formName,
            formFile: act.form.formFile,
            langIndex: act.form.langIndex,
          },
          requestInfo: act.requestInfo,
          resultIds: act.resultIds,
        },
      })
        .then((response) => {
          if (response.data.file) {
            const byteCharacters = atob(response.data.file);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            byteArray = new Uint8Array(byteNumbers);
            // file = new Blob([byteArray], { type: 'application/pdf;base64' });
            // const fileURL = URL.createObjectURL(file);

            // window.open(fileURL);

            // If use this can't download file but can preview
            // window.location.replace(fileURL);
          }

          if (response.data.status === false) {
            getError = response.data.error;
          }
        })
        .catch(() => {
        });

      yield put(setResultPreview({
        result: {
          file: byteArray,
          error: getError,
        },
      }));
    });
}

function* requestAttachPreviewFlow() {
  yield takeEvery(ResultPreviewActionConstants.ATTACH_PREVIEW_REQUEST,
    function* _(act: ResultPreviewAction<RequestAttachPreviewArgs>) {
      yield axios(`${config.backendUrl}v1/Result/GetAttachPreview`, {
        headers: {
          Authorization: window.authToken || '',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        data: {
          requestInfo: act.requestInfo,
          attachmentId: act.attachmentId,
          filePath: act.filePath,
        },
      })
        .then((response) => {
          if (response.data.file) {
            const byteCharacters = atob(response.data.file);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const fileType = act.fileType === 'pdf' ? 'application/pdf;base64' : 'image/png;base64';

            const byteArray = new Uint8Array(byteNumbers);
            const file = new Blob([byteArray], { type: fileType });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);

            // If use this can't download file but can preview
            // window.location.replace(fileURL);
          }
        })
        .catch(() => {
          // console.log(error);
        });
      yield put(setAttachPreview());
    });
}

export default function* resultPreviewSaga() {
  yield all([
    initializeFlow(),
    requestResultPreviewFlow(),
    requestAttachPreviewFlow(),
  ]);
}
